import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMagnifierMinus24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconMagnifierMinus24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M11 2a9 9 0 0 1 9 9 8.96 8.96 0 0 1-2.13 5.81l2.9 2.9a.75.75 0 0 1-1.06 1.06l-2.9-2.9A8.96 8.96 0 0 1 11 20a9 9 0 1 1 0-18m0 1.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15m3 6.75a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1 0-1.5z"
            />
        </svg>
    );
}
export default memo(IconMagnifierMinus24);
